const env = process.env.NODE_ENV
export default env
